package co.maytes.standupbot.dashboard.features.rundetail

import co.maytes.standupbot.dashboard.components.motion.ViewPhase
import co.maytes.standupbot.dashboard.lib.api.ApiError
import co.maytes.standupbot.shared.dto.standuprun.StandupRunDetailDto
import com.kttipay.mvi.api.MVIAction
import com.kttipay.mvi.api.MVIIntent
import com.kttipay.mvi.api.MVIState

object RunDetailContract {
    sealed interface Status {
        data object Loading : Status
        data object Ready : Status
        data class Error(val error: ApiError) : Status
    }

    data class State(
        val workspaceId: String = "",
        val runId: String = "",
        val status: Status = Status.Loading,
        val detail: StandupRunDetailDto? = null,
        val rerunInFlight: Boolean = false,
        val regenerateInFlight: Boolean = false,
        val regenerateError: String? = null,
        val draftActionInFlight: Boolean = false,
    ) : MVIState {
        val phase: ViewPhase
            get() = when (status) {
                Status.Loading -> ViewPhase.Loading
                is Status.Error -> ViewPhase.Error
                Status.Ready -> if (detail == null) ViewPhase.Loading else ViewPhase.Ready
            }
    }

    sealed interface Intent : MVIIntent {
        data class Load(val workspaceId: String, val runId: String) : Intent
        data object Retry : Intent
        data object Back : Intent
        data object BackToList : Intent
        data object Rerun : Intent
        data class Regenerate(val model: String) : Intent
        data object DismissRegenerateError : Intent
        data object PostDraftNow : Intent
        data object DiscardDraft : Intent
    }

    sealed interface Action : MVIAction {
        data class Navigate(val path: String) : Action
        data class Toast(val message: String, val error: Boolean = false) : Action
    }
}
